// extracted by mini-css-extract-plugin
module.exports = {"Modal":"CompressProcess_Modal__3m13F"};